export var Environments = ["development", "staging", "production"];
export var CountryNames = {
    "DE": "Germany",
    "BS": "Bahamas",
    "ZA": "South Africa"
};
export var Countries = ["DE", "BS", "ZA"];



//////////////////
// WEBPACK FOOTER
// ./src/data/types.ts
// module id = 1230
// module chunks = 0